import React from 'react';
import PropTypes from 'prop-types';
import exact from 'prop-types-exact';
import { connect } from 'react-redux';
import { compose } from 'recompose';
import {
  FormGroup,
  Col,
  Row,
  ControlLabel,
  Button,
  ButtonToolbar,
} from 'react-bootstrap';

import { reduxForm, formPropTypes } from 'redux-form';
import { PhoneNumberField } from '../../fields';
import { requestOnetimePassword } from './actions';
import PageLayout from '../../../layouts/PageLayout';
import { getPassword } from './selectors';


const propTypes = exact({
  handleSubmit: PropTypes.func.isRequired,
  error: PropTypes.string,
  ...formPropTypes,
});

const validate = (values) => {
  const errors = {};

  if (!values.name) {
    errors.name = 'Required';
  }
  return errors;
};

const OnetimePassword = (props) => {
  const {
    handleSubmit,
    error,
    invalid,
    pristine,
    submitting,
    requestOnetimePasswordAction,
    onetimePassword,
  } = props;

  const formSubmit = async (values) => {
    await requestOnetimePasswordAction(values.cell_number);
  };

  return (
    <PageLayout
      title="Request Mobile Login Password"
      render={() => {
        return (
          <div>
            <Row>
              <Col md={4}>
                <form onSubmit={handleSubmit(formSubmit)}>
                  <Row>
                    <Col md={12}>
                      <FormGroup>
                        <PhoneNumberField name="cell_number" label="Cell Number" />
                      </FormGroup>
                    </Col>
                  </Row>
                  {onetimePassword
                  && (
                  <div>
                    <Row>
                      <Col md={12}>
                        <ControlLabel>Onetime Password: {onetimePassword}</ControlLabel>
                      </Col>
                    </Row>
                    <Row>
                      <Col md={12}>
                        <ControlLabel>Passwords are valid for 10 minutes</ControlLabel>
                      </Col>
                    </Row>
                  </div>
                  )}
                  <Row>
                    <Col md={12}>
                      <ButtonToolbar className="pull-right">
                        <Button bsStyle="primary" type="submit" disabled={submitting || pristine || invalid}>Request
                          Password
                        </Button>
                      </ButtonToolbar>
                    </Col>
                  </Row>
                  <label>{error && <strong>{error}</strong>}</label>
                </form>
              </Col>
            </Row>
          </div>
        );
      }}
    />
  );
};

OnetimePassword.propTypes = propTypes;

const withForm = reduxForm({
  form: 'OnetimePassword',
  validate,
});

const mapStateToProps = (state) => {
  return {
    onetimePassword: getPassword(state),
  };
};

const mapDispatchToProps = {
  requestOnetimePasswordAction: requestOnetimePassword,
};

const withRedux = connect(mapStateToProps, mapDispatchToProps);

const enhance = compose(
  withForm,
  withRedux,
);

export default enhance(OnetimePassword);
